const paths = {
  home: '/',
  questionnaire: '/questionnaire',
  resultsType: '/type',
  zip: '/zip',
};

export default paths;
